import { render, staticRenderFns } from "./BaseMobilePage.vue?vue&type=template&id=863b3470&scoped=true&"
import script from "./BaseMobilePage.vue?vue&type=script&lang=js&"
export * from "./BaseMobilePage.vue?vue&type=script&lang=js&"
import style0 from "./BaseMobilePage.vue?vue&type=style&index=0&id=863b3470&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "863b3470",
  null
  
)

export default component.exports